import { useSelector } from 'react-redux';
import { selectAllFeatureFlags } from 'redux/client-config/client-config.selectors';
import { selectAllPermissions } from 'redux/user/user.selectors';
import { pruneRoutes } from 'util/access';

export const usePrunedRoutes = (routes: any[]) => {
  const allPermissions = useSelector(selectAllPermissions);
  const allFeatureFlags = useSelector(selectAllFeatureFlags);

  return pruneRoutes(routes, allPermissions, allFeatureFlags);
};
